import Vue from 'vue'
import VueRouter from 'vue-router'
// 物件一覧 レイアウト
const LayoutDefault = () => import(/* webpackChunkName: "layout-default" */ '@/components/layouts/Default.vue')
// 居住一覧
import Residence from './modules/residence'
// 投資一覧
import Investment from './modules/investment'
// マップ
const Map = () => import(/* webpackChunkName: "page-map" */ '@/components/pages/Map.vue')
// 画像ビューアー
const ImageViewer = () => import(/* webpackChunkName: "page-image_viewer" */ '@/components/pages/ImageViewer.vue')
// エラー
const Error = () => import(/* webpackChunkName: "page-error" */ '@/components/pages/Error.vue')
// 404
const NotFound = () => import(/* webpackChunkName: "page-notfound" */ '@/components/pages/NotFound.vue')
Vue.use(VueRouter)

const routes = [
  {
    path: ``,
    redirect: {
      name: 'residence-list',
    },
  },

  {
    path: `/residence`,
    component: LayoutDefault,
    children: [...Residence],
  },
  {
    path: `/investment`,
    component: LayoutDefault,
    children: [...Investment],
  },
  {
    path: `/map/:id`,
    name: 'map',
    component: Map,
    meta: {
      title: 'マップ',
      requiresAuth: true,
    },
  },
  {
    path: `/image_viewer/:id`,
    name: 'image-viewer',
    component: ImageViewer,
    meta: {
      title: '画像ビューアー',
      requiresAuth: true,
    },
  },
  {
    path: `/error`,
    name: 'error',
    component: Error,
    meta: {
      title: 'エラー',
    },
  },
  {
    path: '*',
    name: 'notfound',
    component: NotFound,
    meta: {
      title: '404',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
